<template>
    <div class="profile-finance">
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
        <Toast />

        <div class="profile-account-inner">
            <div class="profile-finance-content">
                <h2>Info</h2>
                <div class="profile-finance-body">
                    <div class="form-item">
                        <label for="bank-name">Bank Name</label>
                        <InputText id="bank-name" placeholder="Bank Name" v-model="bank.name" />
                    </div>
                    <div class="form-item">
                        <label for="bank-address">Bank Address</label>
                        <InputText id="bank-address" placeholder="Bank Address" v-model="bank.address" />
                    </div>
                    <div class="form-item">
                        <label for="bank-zip-code">Bank ZIP code</label>
                        <InputText id="bank-zip-code" placeholder="Bank ZIP code" v-model="bank.zip" />
                    </div>
                    <div class="form-item">
                        <label for="bank-city">Bank City</label>
                        <InputText id="bank-city" placeholder="Bank City" v-model="bank.city" />
                    </div>
                    <div class="form-item">
                        <label for="bank-country">Bank Country</label>
                        <InputText id="bank-country" placeholder="Bank Country" v-model="bank.country" />
                    </div>
                    <div class="form-item">
                        <label for="account-name">Account Name</label>
                        <InputText id="account-name" placeholder="Account Name" v-model="bank.account_name" />
                    </div>
                    <div class="form-item">
                        <label for="account-number">Account Number</label>
                        <InputText id="account-number" placeholder="Account Number" v-model="bank.account_number" />
                    </div>
                    <div class="form-item">
                        <label for="account-signatory">Account Signatory</label>
                        <InputText id="account-signatory" placeholder="Account Signatory" v-model="bank.account_signatory_person" />
                    </div>
                    <div class="form-item">
                        <label for="swift-bic">SWIFT/BIC</label>
                        <InputText id="swift-bic" placeholder="SWIFT/BIC" v-model="bank.swift" />
                    </div>
                    <div class="form-item">
                        <label for="iban">IBAN</label>
                        <InputText id="iban" placeholder="IBAN" v-model="bank.iban" />
                    </div>
                    <div class="form-item">
                        <label for="btc-wallet">BTC Wallet</label>
                        <InputText id="btc-wallet" placeholder="BTC Wallet" v-model="bank.btc_wallet" />
                    </div>
                    <div class="form-item">
                        <label for="payment_type">Payout type</label>
                        <Dropdown v-model="bank.payment_type" :options="types.payment" class="p-column-filter">
                            <template #option="payment_type">
                                <span>{{ payment_type.option }}</span>
                            </template>
                        </Dropdown>
                    </div>
                    <div class="form-action">
                        <Button @click="updateFinancialData()" label="Save Financial Data" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import UserService from '../../service/UserService.js';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    const validateName = (value, vm) => {
        if (vm.account_number !== '' && value == '') {
            return false
        }
        if (vm.iban !== '' && value == '') {
            return false
        }
        if (vm.btc_wallet !== '') return true
        else return true
    }

    const validateAddress = (value, vm) => {
        if (vm.account_number !== '' && value == '') return false
        if (vm.iban !== '' && value == '') return false
        if (vm.btc_wallet !== '') return true
        else return true
    }

    const validateZip = (value, vm) => {
        if (vm.account_number !== '' && value == '') return false
        if (vm.iban !== '' && value == '') return false
        if (vm.btc_wallet !== '') return true
        else return true
    }

    const validateCity = (value, vm) => {
        if (vm.account_number !== '' && value == '') return false
        if (vm.iban !== '' && value == '') return false
        if (vm.btc_wallet !== '') return true
        else return true
    }

    const validateCountry = (value, vm) => {
        if (vm.account_number !== '' && value == '') return false
        if (vm.iban !== '' && value == '') return false
        if (vm.btc_wallet !== '') return true
        else return true
    }

    const validateAccount_name = (value, vm) => {
        if (vm.account_number !== '' && value == '') return false
        if (vm.iban !== '' && value == '') return false
        if (vm.btc_wallet !== '') return true
        else return true
    }

    const validateAccount_number = (value, vm) => {
        if (vm.iban == '' && vm.btc_wallet == '' && value == '') return false
        else return true
    }

    const validateAccount_signatory_person = (value, vm) => {
        if (vm.account_number !== '' && value == '') return false
        if (vm.iban !== '' && value == '') return false
        if (vm.btc_wallet !== '') return true
        else return true
    }

    const validateSwift = (value, vm) => {
        if (vm.account_number !== '' && value == '') return false
        if (vm.iban !== '' && value == '') return false
        if (vm.btc_wallet !== '') return true
        else return true
    }

    const validateIban = (value, vm) => {
        if (vm.account_number == '' && vm.btc_wallet == '' && value == '') return false
        else return true
    }

    const validateBtc_wallet = (value, vm) => {
        if (vm.iban == '' && vm.account_number == '' && value == '') return false
        else return true
    }


    export default {
        data() {
            return {
                bank: {
                    name: '',
                    address: '',
                    zip: '',
                    city: '',
                    country: '',
                    account_name: '',
                    account_number: '',
                    account_signatory_person: '',
                    swift: '',
                    iban: '',
                    btc_wallet: '',
                    payment_type:'',
                },
                apiUrl: process.env.VUE_APP_AUTH_URL + 'api/v1/kyc',
                staticUrl: process.env.VUE_APP_AUTH_URL,
                referralLink: null,
                name: null,
                surname: null,
                email: null,
                isLoading: false,
                validation_error: '',
                types: {
                    payment: ['BNK', 'CRY', 'CSH', 'CC'],
                },
                payment_type:'',
            }
        },
        components: {
            Loading
        },
        validations: {
            bank: {
                name: {
                    validateName,
                },
                address: {
                    validateAddress,
                },
                zip: {
                    validateZip,
                },
                city: {
                    validateCity,
                },
                country: {
                    validateCountry,
                },
                account_name: {
                    validateAccount_name,
                },
                account_number: {
                    validateAccount_number,
                },
                account_signatory_person: {
                    validateAccount_signatory_person,
                },
                swift: {
                    validateSwift,
                },
                iban: {
                    validateIban,
                },
                btc_wallet: {
                    validateBtc_wallet,
                },
            }
        },
        created() {
            this.$store.commit('setPageTitle', { pageTitle: 'Financial data' });
            this.userService = new UserService()
        },
        mounted() {
            this.bank = {
                name: this.$store.state.currentUser.bank_name,
                address: this.$store.state.currentUser.bank_address,
                zip: this.$store.state.currentUser.bank_zip,
                city: this.$store.state.currentUser.bank_city,
                country: this.$store.state.currentUser.bank_country,
                account_name: this.$store.state.currentUser.account_name,
                account_number: this.$store.state.currentUser.account_number,
                account_signatory_person: this.$store.state.currentUser.account_signatory_person,
                swift: this.$store.state.currentUser.swift,
                iban: this.$store.state.currentUser.iban,
                btc_wallet: this.$store.state.currentUser.btc_wallet,
                payment_type: this.$store.state.currentUser.payment_type,
            }
        },
        methods: {
            updateFinancialData() {
                if (!this.$v.$invalid) {
                    this.isLoading = true
                    this.userService.updateUserBank(this.bank)
                    this.$store.commit('updateFinancialData', this.bank)
                    this.isLoading = false
                    this.$toast.add({ severity: 'success', summary: 'Financial data saved!', life: 3000 });
                } else {
                    console.log(1);

                    this.validation_error = this.parseValidationErrors()
                    this.$toast.add({
                        severity: "error",
                        detail: this.validation_error,
                        summary: "Financial data save failed",
                        life: 3000,
                        position: "topleft"
                    });
                }
            },

            parseValidationErrors() {
                let errorMessage = 'Reguired fields: '
                let errorFields = []
                if (this.$v.bank.name.$invalid) errorFields.push("Bank Name");
                if (this.$v.bank.address.$invalid) errorFields.push("Bank Address");
                if (this.$v.bank.zip.$invalid) errorFields.push("Bank Zip");
                if (this.$v.bank.city.$invalid) errorFields.push("Bank City");
                if (this.$v.bank.country.$invalid) errorFields.push("Bank Country");
                if (this.$v.bank.account_name.$invalid) errorFields.push("Account Name");
                if (this.$v.bank.account_signatory_person.$invalid) errorFields.push("Account Signatory Person");
                if (this.$v.bank.iban.$invalid) errorFields.push("IBAN");
                if (this.$v.bank.btc_wallet.$invalid) errorFields.push("BTC Wallet");
                if (this.$v.bank.account_number.$invalid) errorFields.push("Account Number");
                errorMessage += errorFields.join(', ')
                return errorMessage
            }
        }
    }

</script>

<style>
</style>